(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fcsp-jersey-configurator"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fcsp-jersey-configurator')) {
    customElements.define('fcsp-jersey-configurator', class extends HTMLElement {
      connectedCallback() {
        this.data = JSON.parse(this.querySelector('[data-configurator-data]').textContent);
        this.form = this.querySelector('[data-configurator-form]');
        this.defaultButtonLabel = this.querySelector('[data-button-label]').textContent;
        this.currency = new Intl.NumberFormat(this.dataset.locale, { style: 'currency', currency: this.dataset.currency });
        this.form.addEventListener('change', (event) => this.handleChange(event));
        this.form.addEventListener('submit', (event) => this.submit(event));
        this.renderJerseys();
      }

      get season() { return this.form.elements.season.value; }
      get jersey() { return this.data.jerseys.find((item) => item.handle === this.form.elements.jersey.value); }
      get variant() { return this.jersey?.variants.find((item) => String(item.id) === this.form.elements.variant.value); }

      handleChange(event) {
        const changed = event.target.name;
        if (changed === 'season') this.renderJerseys();
        else if (changed === 'jersey') this.renderVariants();
        else this.renderDetails();
      }

      renderJerseys() {
        const jerseys = this.data.jerseys.filter((item) => item.season === this.season);
        this.form.elements.jersey.innerHTML = jerseys.map((item) => `<option value="${item.handle}">${item.title}</option>`).join('');
        this.renderPlayers();
        this.renderVariants();
      }

      renderVariants() {
        if (!this.jersey) {
          this.form.elements.variant.innerHTML = '';
          this.renderDetails();
          return;
        }
        this.form.elements.variant.innerHTML = this.jersey.variants.map((variant) => `<option value="${variant.id}" ${variant.available ? '' : 'disabled'}>${variant.title}${variant.available ? '' : ` · ${this.data.labels.sold_out}`}</option>`).join('');
        const firstAvailable = this.jersey.variants.find((variant) => variant.available);
        if (firstAvailable) this.form.elements.variant.value = String(firstAvailable.id);
        this.renderDetails();
      }

      renderPlayers() {
        const players = (this.data.players[this.season] || '').split(/\r?\n/).map((player) => player.trim()).filter(Boolean);
        this.form.elements.player.innerHTML = players.map((player) => `<option value="${player}">${player}</option>`).join('');
      }

      renderDetails() {
        const components = this.data.components[this.season];
        const playerInput = this.form.querySelector('[name="back_print"][value="player"]');
        const individualInput = this.form.querySelector('[name="back_print"][value="individual"]');
        const leagueInput = this.form.elements.league_patch;
        const astraInput = this.form.elements.astra_patch;
        const leagueComponent = this.jersey?.kids ? components.league_kids : components.league_adult;
        playerInput.disabled = !components.player.available || !this.form.elements.player.options.length;
        individualInput.disabled = !components.individual.available;
        leagueInput.disabled = !this.jersey || !leagueComponent.available;
        astraInput.disabled = !this.data.components.astra.available;
        if (this.form.elements.back_print.value === 'player' && playerInput.disabled) this.form.elements.back_print.value = 'none';
        if (this.form.elements.back_print.value === 'individual' && individualInput.disabled) this.form.elements.back_print.value = 'none';
        if (leagueInput.disabled) leagueInput.checked = false;
        if (astraInput.disabled) astraInput.checked = false;
        const printType = this.form.elements.back_print.value;
        this.querySelector('[data-player-field]').hidden = printType !== 'player';
        this.querySelector('[data-individual-fields]').hidden = printType !== 'individual';
        this.querySelector('[data-league-label]').textContent = this.data.league_labels[this.season] || '';
        this.renderComponentPrice('player', components.player);
        this.renderComponentPrice('individual', components.individual);
        this.renderComponentPrice('league', leagueComponent);
        this.renderComponentPrice('astra', this.data.components.astra);
        if (this.jersey) {
          const image = this.querySelector('[data-jersey-image]');
          image.src = this.jersey.image;
          image.alt = this.jersey.title;
          this.querySelector('[data-summary-title]').textContent = this.jersey.title;
          this.querySelector('[data-summary-size]').textContent = this.variant?.title || '';
        }
        this.renderTotal();
      }

      renderComponentPrice(key, component) {
        const target = this.querySelector(`[data-component-price="${key}"]`);
        if (!target) return;
        target.textContent = component?.available ? ` · +${this.currency.format(component.price / 100)}` : ` · ${this.data.labels.sold_out}`;
      }

      renderTotal() {
        if (!this.variant) {
          this.querySelector('[data-total]').textContent = '';
          return;
        }
        const components = this.data.components[this.season];
        let total = this.variant.price;
        if (this.form.elements.back_print.value === 'player') total += components.player.price;
        if (this.form.elements.back_print.value === 'individual') total += components.individual.price;
        if (this.form.elements.league_patch.checked) total += (this.jersey.kids ? components.league_kids : components.league_adult).price;
        if (this.form.elements.astra_patch.checked) total += this.data.components.astra.price;
        this.querySelector('[data-total]').textContent = this.currency.format(total / 100);
      }

      async submit(event) {
        event.preventDefault();
        const error = this.querySelector('[data-error]');
        error.hidden = true;
        const printType = this.form.elements.back_print.value;
        const components = this.data.components[this.season];
        const leagueComponent = this.jersey?.kids ? components.league_kids : components.league_adult;
        if (!this.variant || !this.variant.available) return this.showError(this.dataset.requiredError);
        if (printType === 'individual' && (!this.form.elements.individual_name.value.trim() || !this.form.elements.individual_number.value.trim())) return this.showError(this.dataset.requiredError);
        if (printType === 'player' && !components.player.available) return this.showError(this.dataset.requiredError);
        if (printType === 'individual' && !components.individual.available) return this.showError(this.dataset.requiredError);
        if (this.form.elements.league_patch.checked && !leagueComponent.available) return this.showError(this.dataset.requiredError);
        if (this.form.elements.astra_patch.checked && !this.data.components.astra.available) return this.showError(this.dataset.requiredError);
        const prefix = this.data.configuration.prefix.trim();
        const configurationId = `${prefix ? `${prefix}-` : ''}${Date.now().toString(36).toUpperCase()}`;
        const groupProperty = { '_Konfiguration': configurationId };
        const items = [{ id: this.variant.id, quantity: 1, properties: groupProperty }];
        const componentItem = (id, properties = groupProperty) => ({
          id,
          quantity: 1,
          parent_id: this.variant.id,
          properties
        });

        if (printType === 'player') {
          items.push(componentItem(components.player.id, { ...groupProperty, 'Flock': this.form.elements.player.value }));
        }
        if (printType === 'individual') {
          const number = this.form.elements.individual_number.value.trim();
          const name = this.form.elements.individual_name.value.trim().toUpperCase();
          items.push(componentItem(components.individual.id, { ...groupProperty, 'Flock': `${number} ${name}` }));
        }
        if (this.form.elements.league_patch.checked) {
          items.push(componentItem(leagueComponent.id));
        }
        if (this.form.elements.astra_patch.checked) {
          items.push(componentItem(this.data.components.astra.id));
        }

        const button = this.form.querySelector('button[type="submit"]');
        button.disabled = true;
        this.querySelector('[data-button-label]').textContent = this.dataset.adding;
        try {
          const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items })
          });
          if (!response.ok) throw new Error(await response.text());
          if (this.data.configuration.test_mode) {
            const attributes = {};
            if (this.data.configuration.test_order_attribute_name) {
              attributes[this.data.configuration.test_order_attribute_name] = this.data.configuration.test_order_attribute_value;
            }
            if (this.data.configuration.fulfillment_attribute_name) {
              attributes[this.data.configuration.fulfillment_attribute_name] = this.data.configuration.fulfillment_attribute_value;
            }
            if (Object.keys(attributes).length) {
              const cartResponse = await fetch(`${window.Shopify.routes.root}cart/update.js`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ attributes })
              });
              if (!cartResponse.ok) throw new Error(await cartResponse.text());
            }
          }
          window.location.assign(`${window.Shopify.routes.root}cart`);
        } catch (requestError) {
          this.showError(this.dataset.addError);
          button.disabled = false;
          this.querySelector('[data-button-label]').textContent = this.defaultButtonLabel;
        }
      }

      showError(message) {
        const error = this.querySelector('[data-error]');
        error.textContent = message;
        error.hidden = false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    const scrollToCard = () => {
      const card = document.getElementById(url.hash.slice(1));
      if (!card) return;
      history.scrollRestoration = 'manual';
      card.scrollIntoView({ behavior: 'instant', block: 'start' });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', scrollToCard, { once: true });
    } else {
      scrollToCard();
    }

    window.addEventListener('pageshow', scrollToCard);
    window.addEventListener('load', scrollToCard, { once: true });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search-results"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    const scrollToCard = () => {
      const card = document.getElementById(url.hash.slice(1));
      if (!card) return;
      history.scrollRestoration = 'manual';
      card.scrollIntoView({ behavior: 'instant', block: 'start' });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', scrollToCard, { once: true });
    } else {
      scrollToCard();
    }

    window.addEventListener('pageshow', scrollToCard);
    window.addEventListener('load', scrollToCard, { once: true });
  }

  } catch(e) { console.error(e); }
})();
})();
